<template>
  <div class="transaction-item basic-box">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="row no-gutters">
          <div class="transaction-amount">
            <span>{{transaction.amount}}</span>
          </div>
          <div class="participants">
            <router-link
              class="user-name-link"
              :to="`/users/${transaction.senderUser._id}`"
            >{{transaction.senderUser.userName}}</router-link>→
            <router-link
              class="user-name-link"
              :to="`/users/${transaction.receiverUser._id}`"
            >{{transaction.receiverUser.userName}}</router-link>
            <font-awesome-icon @click="duplicate" :icon="'hands-clapping'" class="duplicate-icon" />
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-12 reason">"{{transaction.reason}}"</div>
    </div>
    <div class="row no-gutters">
      <div
        class="col-4 time"
        :title="transaction.time | formatDate"
      >{{transaction.time | moment("from")}}</div>
      <div class="col category">
        <div
          class="category-icon"
          :title="transaction.coreValue.name"
          v-html="transaction.coreValue.emoji"
            />
        {{transaction.coreValue.name}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FeedbackModal from '@/components/shared/modals/FeedbackModal';
import CategoryIcons from '@/components/shared/categoryIcons';

export default {
  name: 'Transaction',
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },
  mixins: [CategoryIcons],
  methods: {
    duplicate() {
      this.$eventBus.showModal({
        bind: {
          is: FeedbackModal,
          receiverUserId: this.transaction.receiverUser._id,
          initialReason: this.transaction.reason,
          initialAmount: this.transaction.amount,
          initialCategory: this.transaction.category,
          parentId: this.transaction._id,
        },
      });
    },
    iconForCategory(category) {
      const categories = ['seedling', 'rocket', 'smile-beam', 'users'];
      return categories[category];
    },
  },
  computed: {
    ...mapGetters({
      loggedInUserProfile: 'users/loggedInUserProfile',
    }),
  },
};
</script>

<style lang="scss" scoped>
.transaction-item {
  margin: 10px 0;
  background-color: white;
  &:hover {
    .duplicate-icon {
      visibility: visible;
    }
  }
  .duplicate-icon {
    visibility: hidden;
    cursor: pointer;
    color: #fff;
    background-color: $primary-hover-color;
    padding: 5px;
    margin-bottom: 3px;
    margin-left: 10px;
    font-size: 30px;
    border-radius: 15px;
  }
  .row {
    margin: 5px 0;
  }
  .transaction-amount {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
    margin-right: 15px;
    span {
      background-color: $primary-hover-color;
      color: white;
      padding: 3px 8px 0px 8px;
      border-radius: 50%;
      min-width: 30px;
    }
  }
  .participants {
    text-align: left;
    padding-top: 3px;
  }
  .reason {
    color: $primary-color;
    font-style: italic;
    min-height: 60px;
    text-align: left;
    display: flex;
    align-items: center;
  }
  .time {
    text-align: left;
    color: #cccccc;
  }
  .category {
    text-align: right;
    color: #ccc;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .category-icon {
      max-height: 32px;
    }
  }
}
</style>

